import '@components/atnl-select/script.js'
import { atempl as endpoints } from '@api/v0/fetch/.endpoints';
import atnlConsolePrint from '@resources/atnl-console-print/atnlConsolePrint';
import MediaWidthObserver from '@resources/media-width-observer/MediaWidthObserver';
import { SwiperSetup } from '@resources/swiper-setup/SwiperSetup';
import Menu from '@components/topbar/script.js';

import '@components/atnl-select/script';
import '@components/single-video/script';
import '@components/single-staff/script';
import '@components/ten-by-ten/script';
import '@components/book/script';
import '@components/cookie-bar/script';
import '@components/post-password/script';
import '@components/popup/script'
import '@components/explore/request';
import '@components/explore/view';

import '@blocks/blocks.scripts';

atnlConsolePrint();
SwiperSetup.init();
endpoints.init();

new MediaWidthObserver();
new Menu();
